<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n2">{{$t("Users")}}</h1>
        </v-flex>

          <v-layout row wrap>
            <v-text-field class="ml-2 mr-2"
              v-model="searchText"
              append-icon="mdi-magnify"
              :label="$t('Search')"
              solo
              hide-details
              shrink
            ></v-text-field>

            <v-select
              class="ml-3"
              v-if="isAdmin()"
              :items="corporations"
              v-model="corporation"
              :label="ct.Corporation"
              :no-data-text="ct.NoDataAvailable">
            </v-select>
            <v-checkbox
              class="ml-2 mr-3"
              :label="ct.Show_inactive"
              v-model="showInactive"
              :color="'primary'"
            ></v-checkbox>
          </v-layout>
        <v-flex xs12>
          <v-btn :loading="loading" class="ml-1 mt-n1 mr-2" color="primary" @click="loadData">
            <v-icon left>search</v-icon>
            {{ $t('Search') }}
          </v-btn>
          <v-btn class="ml-2 mt-n1" to="users/create" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

        <v-flex v-else xs12>
          <v-data-table
            :headers="headers"
            :items="users.filter(item => (showInactive || item.DeletedDate === null) && (corporation == 0 || item.CorporationId == corporation))"
            class="elevation-1 mt-2"
            sortBy="FullName"
            item-key="Id"
            show-expand
            v-if="users.filter(item => (showInactive || item.DeletedDate === null) && (corporation == 0 || item.CorporationId == corporation)).length > 0"
          >
            <template v-slot:[`item.CreatedDate`]="{ item }">
              {{ formatDate(item.CreatedDate) }}
            </template>
            <template v-slot:[`item.DeletedDate`]="{ item }">
              {{ formatDate(item.DeletedDate) }}
            </template>
             <template v-slot:[`item.LastAliveDate`]="{ item }">
              {{ formatDate(item.LastAliveDate) }}
            </template>
             <template v-slot:[`item.Alive`]="{ item }">
              {{ $t(item.Alive.toString()) }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-btn color="primary" :to="{name: 'editUser', params: {id: item.Id}}">
                  <v-icon left>edit</v-icon>
                  {{$t("Edit")}}
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import ct from '@/core/mixins/common-translations'
import filters from '@/core/mixins/common-filters'
import * as Admin from '@/core/admin'
import * as License from '@/core/license'
import * as Security from '@/core/security'
import formatDate from '@/core/mixins/formatDate'

export default {
  mixins: [ct, filters, formatDate],

  data () {
    return {
      loading: false,
      corporation: 0,
      showInactive: false,
      corporations: [],
      users: [],
      searchText: ''
    }
  },

  computed: {
    headers () {
      const resAdmin = [
        {
          text: this.$t('Corp.'),
          value: 'CorporationId'
        }
      ]

      const resNotAdmin = [
        {
          text: this.$t('Username'),
          value: 'Name'
        },
        {
          text: this.$t('Full name'),
          value: 'FullName'
        },
        {
          text: this.$t('Email'),
          value: 'Email'
        },
        {
          text: this.$t('Created'),
          value: 'CreatedDate'
        },
        {
          text: this.$t('Online'),
          value: 'Alive'
        },
        {
          text: this.$t('Latest login'),
          value: 'LastAliveDate'
        },
        {
          text: this.$t('Inactive'),
          value: 'DeletedDate',
          selected: false
        }
      ]

      return this.isAdmin() ? resAdmin.concat(resNotAdmin) : resNotAdmin
    }
  },

  methods: {
    isAdmin () {
      return Security.hasAccess([License.adminNo])
    },
    async loadData () {
      this.loading = true
      const res = await Admin.loadUsers({ searchText: this.searchText })
      if (!res.failed) {
        this.users = res.data
      }
      this.loading = false
    }
  },

  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Load all corporations if current user has claim 10.
    if (this.isAdmin()) {
      const res = await Admin.loadCorporations()
      if (!res.failed) {
        this.corporations = res.data.map(item => {
          return {
            text: item.Name,
            value: item.Id
          }
        })
      }
      this.corporations.splice(0, 0, { text: this.$t('(ALL CORPORATIONS)'), value: 0 })
    }
  }
}
</script>
